import { React, useState, useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getAggregatedFlow } from "../../../../../redux/actions/skill";
import FlowBuilder, {
  NodeContext,
  BuilderContext,
  buildFlatNodes,
  buildTreeNodes,
  useAction,
} from "react-flow-builder";
import _ from "lodash";
import { v4 as uuid } from "uuid";
import arrowDownStart from "../../../../../images/arrow-down-start.svg";
import { Drawer, Popover } from "antd";
import settingIcon from "../../../../../images/branching/setting-icon.svg";
import Loader from "../../../../../components/loader";
import { notify } from "../../../../../components/Snack";
import unauthorizedIcon from "../../../../../images/403-Error-pana.png";
import addModeIcon from "../../../../../images/sameStep.png";
import diffModeIcon from "../../../../../images/diff-mode.png";
import newAddition from "../../../../../images/newAdd.png";

import infoIcon from "../../../../../images/info.png";

import ProcessAction from "./ProcessAction";
import Zoom from "react-medium-image-zoom";
import {
  addToCompare,
  setAggregateData,
} from "../../../../../redux/actions/skill";
import { useHistory } from "react-router-dom";
const AggregateFlow = () => {
  let dataToProcess = [];
  const dispatch = useDispatch();
  const history = useHistory();
  const [nodes, setNodes] = useState([]);

  const [customClassName, setCustomClassName] = useState("");

  const [loader, setLoader] = useState(false);
  let [validNodes, setValidNodes] = useState([]);
  const [currentNode, setCurrentNode] = useState();

  const [panelData, setPanelData] = useState({});
  const [showPanel, setShowPanel] = useState(false);

  const userRole = useSelector(
    (state) => state.organizationReducer?.currentOrgUser
  );
  const userSub = useSelector((state) => state.userReducer?.user?.sub);
  const userEmail = useSelector((state) => state.userReducer?.user?.email);
  const readOnly = useSelector((state) => state.skillReducer?.readOnly);
  const _flow = useSelector((state) => state.skillReducer?.compareFlow);
  const _flow2 = useSelector(
    (state) => state.skillReducer?.compareFlow[1]?.document?.actions
  );
  const skillInfo = useSelector((state) => state.skillReducer?.compareFlow[0]);

  const _aggData = useSelector((state) => state.skillReducer?.aggregatedFlow);
  const [aggData, setAggData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [errored, setIsErrored] = useState(false);
  const [baseVariant, setBaseVariant] = useState([]);
  const [otherVariant, setOtherVariant] = useState([]);

  const setVariantInfo = () => {
    let _baseVariant = [];
    let _otherVariant = [];

    _flow?.map((f, i) => {
      if (i == 0) {
        _baseVariant.push(f.revision);
      } else {
        _otherVariant.push(f.revision);
      }
    });
    setBaseVariant(_baseVariant);
    setOtherVariant(_otherVariant);
  };

  useEffect(() => {
    if (_flow) {
      setVariantInfo();
    }
    fetchData();
    return () => {
      dispatch(addToCompare([]));
      dispatch(setAggregateData([]));
    };
  }, []);

  const fetchData = async () => {
    if (_flow) {
      setIsLoading(true);
      let res = await dispatch(getAggregatedFlow(_flow));
      if (res?.data?.data !== null) {
        setAggData(res?.data?.data);
        setValidNodes(registerNodes);
        let _actions = _.cloneDeep(res?.data?.data);

        let actions = getRearrangedData(_actions || []);
        if (actions?.length == 0) {
          dispatch(notify("info", "No diff found"));
        }
        setNodes(actions);
        setIsLoading(false);
      } else {
        dispatch(
          notify(
            "error",
            "No Valid data to aggregate.Redirecting to process discovery tab "
          )
        );
        history.push("/dashboard/skills/process-discovery");
        setIsLoading(false);
      }
    } else {
      dispatch(
        notify(
          "error",
          "No Valid data to aggregate.Redirecting to process discovery tab "
        )
      );
      history.push("/dashboard/skills/process-discovery");
      setIsErrored(true);
      setIsLoading(false);
    }
  };
  const openPanel = (d) => {
    setShowPanel(true);
    setPanelData(d);
  };

  const handleCancel = () => {
    setShowPanel(false);
    setPanelData({});
  };

  const getNode = (type, child = false) => {
    return {
      step: {
        id: uuid(),
        type: type,
        name: type,
        actionType: type,
        children: child ? [] : undefined,
        isStart: type === "start",
        isEnd: type === "end",
      },
      changes: [],
      newAdditions: {},
      type: type,
    };
  };

  const getChildNode = (c) => {
    let children = [];
    for (let i = 0; i <= c.changes?.length - 1; i++) {
      if (c.changes[i]) {
        c.changes[i]["type"] = "diff";
        c.changes[i]["actionType"] = c?.changes[i]?.actionType;
        c.changes[i]["variantId"] = c?.changes[i]?.variantId;

        let _data = {
          id: uuid(),
          type: "condition",
          name: "diff node",
          children: [c?.changes[i]],
        };
        children.push(_data);
      }
    }
    return children;
  };
  const getRearrangedData = (actions) => {
    let temp = [];
    temp.push(getNode("start"));
    actions.forEach((a, i) => {
      if (!a.type) {
        if (Object.keys(a?.step).length) {
          if (Object.keys(a?.changes)?.length >= 2) {
            a.type = "branch";
            let childNode = getChildNode(a);
            a["children"] = childNode;
          } else if (
            Object.keys(a?.changes).length == 0 &&
            Object.keys(a?.newAddition).length
          ) {
            a.type = "newNode";
            a.actionType = a?.newAddition?.actionType;
          } else {
            a.type = a?.step?.type;
            a.actionType = a.step?.actionType;
          }
        } else if (
          Object.keys(a?.step).length == 0 &&
          Object.keys(a?.changes).length > 0
        ) {
          a.type = "branch";
          let childNode = getChildNode(a);
          a["children"] = childNode;
        } else if (
          Object.keys(a?.changes).length == 0 &&
          Object.keys(a?.newAddition).length
        ) {
          a.type = "newNode";
          a.actionType = a?.newAddition?.actionType;
        }
        temp.push(a);
      } else {
        a.type = a.type || a.type;
        a.actionType = a.step?.actionType;
        a["variantId"] = a.step?.variantId;

        temp.push(a);
      }
    });
    temp.push(getNode("end"));
    return temp;
  };

  const StartNodeDisplay = () => {
    const node = useContext(NodeContext);
    return (
      <div className="start-node">
        <div className="rt-block rt-start">
          <div
            className="rtb-ico"
            style={{
              backgroundColor: "#02ce9d",
              cursor: "default",
            }}
          >
            <img src={arrowDownStart} alt="" />
          </div>
          <div className="rtb-text">
            <p>Start</p>
          </div>
        </div>
      </div>
    );
  };

  const NodeDisplay = () => {
    const node = useContext(NodeContext);
    let currentNodeLen =
      typeof node?.step == "object" && Object.keys(node?.step).length > 0;

    let newNodeLen =
      typeof node?.step == "object" &&
      Object.keys(node?.newAddition).length > 0;
    let diffLen = node?.changes?.length;
    return (
      <>
        {!diffLen && currentNodeLen && !newNodeLen ? (
          <div
            className={`${
              newNodeLen
                ? "rt-block-full other-node"
                : "rt-block-full other-node"
            } ${node.configuring ? "node-configuring" : ""} ${
              node.validateStatusError ? "node-status-error" : ""
            }`}
            onClick={() =>
              openPanel(currentNodeLen ? node.step : node?.newAddition)
            }
          >
            <div className="agg-new-add">
              <img src={addModeIcon} style={{ width: "30px" }} />
              {/* <p className="agg-textId">{`Variant Id: ${node?.step?.variantId}`}</p> */}

              <p style={{ margin: "5px 0px 0px " }}>{node.actionType}</p>
            </div>
          </div>
        ) : null}
      </>
    );
  };

  const DiffNodeDisplay = () => {
    const node = useContext(NodeContext);
    return (
      <>
        <div
          className={`rt-block-full other-node ${
            node.configuring ? "node-configuring" : ""
          } ${node.validateStatusError ? "node-status-error" : ""}`}
          onClick={() => openPanel(node)}
        >
          <div className="rth-title">
            <div className="tl-cont">
              <div className="rth-tooltip agg-new-add">
                <p className="agg-textId">Variant Id: {node?.variantId}</p>
                <p>{node?.actionType}</p>
              </div>
            </div>
          </div>
          {/* <span className="setting-icon" onClick={() => openPanel(node)}>
            <img src={settingIcon} />
          </span> */}
        </div>
      </>
    );
  };
  const EndNodeDisplay = () => {
    const node = useContext(NodeContext);
    return (
      <div className="end-node">
        <div className="rt-block rt-end">
          <div
            className="rtb-ico"
            style={{
              backgroundColor: "#ff3333",
              cursor: "default",
            }}
          >
            <span className="circle"></span>
          </div>
          <div className="rtb-text">
            <p>End</p>
          </div>
        </div>
      </div>
    );
  };

  const ConditionNodeDisplay = () => {
    const node = useContext(NodeContext);
    return (
      <div
        className={` diff-node ${node.configuring ? "node-configuring" : ""} ${
          node.validateStatusError ? "node-status-error" : ""
        } `}
      >
        {/* <div className="rotate-content">
          <h4 className="node-titles">{node?.children[0]?.actionType}</h4>
        </div> */}
        <div className="diff-mode">
          <img src={diffModeIcon} />
        </div>
      </div>
    );
  };

  const NewNodeDisplay = () => {
    const node = useContext(NodeContext);
    let currentNodeLen =
      typeof node?.step == "object" && Object.keys(node?.step).length > 0;

    let newNodeLen =
      typeof node?.step == "object" &&
      Object.keys(node?.newAddition).length > 0;
    let diffLen = node?.changes?.length;
    return (
      <>
        {newNodeLen ? (
          <div
            className={`${
              newNodeLen
                ? "rt-block-full other-node"
                : "rt-block-full other-node"
            } ${node.configuring ? "node-configuring" : ""} ${
              node.validateStatusError ? "node-status-error" : ""
            }`}
            onClick={() =>
              openPanel(currentNodeLen ? node.step : node?.newAddition)
            }
          >
            <div className="agg-new-add">
              <img src={newAddition} style={{ width: "30px" }} />
              <p className="agg-textId">{`Variant Id: ${node?.newAddition?.variantId}`}</p>
              <p>{node.actionType}</p>
            </div>
          </div>
        ) : null}
      </>
    );
  };

  let registerNodes = [
    {
      type: "start",
      name: "start",
      actionType: "start",
      displayComponent: StartNodeDisplay,
      isStart: true,
    },
    {
      type: "end",
      name: "end",
      actionType: "end",
      displayComponent: EndNodeDisplay,
      isEnd: true,
    },

    {
      type: "branch",
      name: "branch",
      actionType: "branch",
      conditionNodeType: "condition",
      deleteConfirmTitle: "Are you sure to delete this action block?",
    },

    {
      type: "record",
      name: "show",
      actionType: "record",
      displayComponent: NodeDisplay,
    },

    {
      type: "condition",
      name: "condition",
      actionType: "condition",
      displayComponent: ConditionNodeDisplay,
      // configComponent: ConfigPanel,
      deleteConfirmTitle: "Are you sure to delete this action block?",
      configTitle: "Configure Condition",
    },

    {
      type: "diff",
      name: "diff",
      actionType: "diff",
      displayComponent: DiffNodeDisplay,
    },
    {
      type: "newNode",
      name: "newNode",
      actionType: "newNode",
      displayComponent: NewNodeDisplay,
    },
  ];

  const Sortable = () => {
    const handleChange = (_nodes, e) => {
      setNodes(_nodes);
    };
  };
  const handleChange = (_nodes, e) => {
    let diff = {};
    switch (e) {
      case "init-builder":
        setNodes(_nodes);
        break;
      case "click-node":
      case "close-drawer":
        break;

      default:
        _nodes = _nodes?.filter((i) => !(i.isStart || i.isEnd));
    }
  };

  const contentBaseVar = (
    <ul className="number-list base-list">
      <li>{baseVariant[0]}</li>
    </ul>
  );
  const contentOtherVar = (
    <ul className="number-list content-list">
      {otherVariant?.map((id) => (
        <li>{id}</li>
      ))}
    </ul>
  );

  return (
    <>
      <div className="compare-page">
        <ProcessAction {...skillInfo} />
        {isLoading ? (
          <Loader
            styles={{ width: "80px", margin: "auto" }}
            root={{ display: "flex" }}
          />
        ) : (
          <>
            {errored ? (
              <div className="template-flex">
                <div className="skill-home scrollable">
                  <div className="auth-block">
                    <div className="auth-block-img">
                      <img src={unauthorizedIcon} />
                    </div>
                    <h3>
                      You are not authorized to view this Page or Page has
                      expired
                    </h3>
                    <button
                      className="btn btn-primary"
                      onClick={() => {
                        window.location.href = "/dashboard/create";
                      }}
                    >
                      Go to dashboard
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <>
                <div className="legend-block">
                  <div className="legend-item">
                    <fieldset>
                      <legend>Aggregation Overview</legend>
                      <div className="color-flex">
                        <div className="color-box">
                          {/* <span className="color-dot" style={{backgroundColor: '#3AA6B9'}}></span> */}
                          <span className="color-icon">
                            <img src={addModeIcon} />
                          </span>
                          <p>Common Step</p>
                        </div>
                        <div className="color-box">
                          {/* <span className="color-dot" style={{backgroundColor: '#FF9EAA'}}></span> */}
                          <span className="color-icon">
                            <img src={newAddition} />
                          </span>
                          <p>New Step</p>
                        </div>
                        <div className="color-box">
                          {/* <span className="color-dot" style={{backgroundColor: '#FFB100'}}></span> */}
                          <span className="color-icon">
                            <img src={diffModeIcon} />
                          </span>
                          <p>Divergent Step</p>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                  <div className="legend-item">
                    <fieldset>
                      <legend>Comparison Overview</legend>
                      <div className="color-flex">
                        <div className="color-box">
                          <span
                            className="color-dot"
                            style={{ backgroundColor: "#D6D5A8" }}
                          ></span>
                          <Popover
                            content={contentBaseVar}
                            title="Base Variant"
                            placement="right"
                          >
                            <p>
                              Base Variant <img src={infoIcon} />
                            </p>
                          </Popover>
                        </div>
                        <div className="color-box">
                          <span
                            className="color-dot"
                            style={{ backgroundColor: "#8CABFF" }}
                          ></span>
                          <Popover
                            content={contentOtherVar}
                            title="Other Variant"
                            placement="right"
                          >
                            <p>
                              Other Variants <img src={infoIcon} />
                            </p>
                          </Popover>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </div>
                {aggData && !isLoading && !errored ? (
                  <FlowBuilder
                    sortable
                    className={`aggregate-flow scrollable ${customClassName}`}
                    nodes={nodes}
                    onChange={handleChange}
                    registerNodes={registerNodes}
                    zoomTool
                    backgroundColor={"#F2F5F6"}
                    readonly={true}
                  />
                ) : null}
              </>
            )}
          </>
        )}
      </div>

      <Drawer
        title="Preview"
        placement="right"
        width={400}
        visible={showPanel}
        onClose={() => handleCancel()}
      >
        {showPanel ? (
          <>
            {" "}
            <div className="compare-data">
              <table className="table table-sm table-striped table-bordered">
                <tbody>
                  {Object.entries(panelData).map(([key, value]) =>
                    typeof value == "string" && value !== "" ? (
                      <tr className="object-detail" key={key}>
                        {key == "pageScreenshot" || key == "image" ? (
                          <td>
                            <span className="stepkey">{key}:</span>
                            <Zoom>
                              <img src={value} alt="step image" />
                            </Zoom>{" "}
                          </td>
                        ) : (
                          <td>
                            <span className="stepkey">{key}:</span>
                            <span className="stepvalue">{value}</span>
                          </td>
                        )}
                      </tr>
                    ) : null
                  )}
                </tbody>
              </table>
            </div>
          </>
        ) : null}
      </Drawer>
    </>
  );
};
export default AggregateFlow;
